export default "__VITE_ASSET__Akpz959X__"